import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const SoporteClienteTotal = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/07-soporte-a-cliente-total.pdf`;
  /*const pdfUrl = "/pdf/07-soporte-a-cliente-total.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Soporte a Cliente Total</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Soporte a Cliente Total" />
      </Container>
    </>
  );
};

 export default SoporteClienteTotal;
